<template>
  <div>
    <el-form 
      role="form" 
      @submit.prevent.native="onSubmit">
      <div class="row">
        <div class="col-md-6">
          <base-input 
            v-uppercase 
            v-model="serviceCategory.label" 
            label="Name"/>
          <base-input 
            v-uppercase 
            v-model="serviceCategory.letter" 
            label="Initial Letter"/>
        </div>
      </div>
      <base-button 
        md 
        type="primary" 
        native-type="submit">Save</base-button>
    </el-form>
  </div>
</template>


<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Select, Option, Form } from "element-ui";
export default {
  directives: {
    uppercase: {
      inserted: function (el, _, vnode) {
        el.addEventListener("input", async function (e) {
          const modified = e.target.value
            .split(" ")
            .map((i) => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      },
    },
  },
  data: () => {
    return {};
  },

  computed: {
    ...mapState("serviceCategory", ["serviceCategory"])
  },

  methods: {
    ...mapActions({
      saveServiceCategory: "serviceCategory/saveServiceCategory",
      getServiceCategoryList: "serviceCategory/getServiceCategoryList",
      updateServiceCategory: "serviceCategory/updateServiceCategory"
    }),

    onSubmit() {
      if (this.serviceCategory.serviceCategoryId) {
        this.updateServiceCategory().then(res => {
          this.$notify({
            message: "Service Category Updated Succesfully!",
            type: "success",
            title: "Succes"
          });
          this.getServiceCategoryList();
          this.$emit("close");
        });
      } else {
        this.saveServiceCategory().then(res => {
          this.$notify({
            message: "Service Category Created Succesfully!",
            type: "success",
            title: "Success"
          });
          this.getServiceCategoryList();
          this.$emit("close");
        });
      }
    }
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Form.name]: Form,
  }
};
</script>